import {Store} from 'extensions/store/lib/store';

export const proformaStore = new Store({name: 'proforma'});
